import Home from '../views/Home';
import Scores from '../views/Scores';
import Rewards from '../views/Rewards';
import TopUp from '../views/TopUp';
import Addadvertisers from '../views/Addadvertisers';

import AdminTransactions from '../views/admin/Transactions';
import AdminGameTransactions from '../views/admin/Answers';
import AdminRewards from '../views/admin/Rewards';
import AdminGiftpay from '../views/admin/Giftpay';
import AdminQuestions from '../views/admin/Questions';
import LastQuestions from '../views/admin/LastQuestions';
import AdminFeatures from '../views/admin/Features';
import Login from '../components/auth/Login';
import Logout from '../components/auth/Logout';
import Register from '../views/Register';
import Questionview from '../views/admin/Questionview';
import AdList from '../views/Adlist';

import Adform from '../components/Adform';

import Adformnew from '../components/Adformnew';
import Editprofile from '../components/Editprofile';

import Transaction from '../components/Transaction';
import Refund from '../components/Refund';
import Changepassword from '../components/Changepassword';
import BannerStudio from '../components/BannerStudio'
const routes = [
    {
        path: '/studio',
        name: 'studio',
        component: BannerStudio,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/balances',
        name: 'balances',
        component: Home,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/gameplay',
        name: 'game-transactions',
        component: AdminGameTransactions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/giftpay',
        name: 'giftpay',
        component: AdminGiftpay,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/questions',
        name: 'questions',
        component: AdminQuestions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/questions-list',
        name: 'questionview',
        component: Questionview,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/last-200-questions',
        name: 'lasttwohundredquestions',
        component: LastQuestions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/transactions',
        name: 'all-transactions',
        component: AdminTransactions,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/rewards',
        name: 'all-rewards',
        component: AdminRewards,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/admin/features',
        name: 'features',
        component: AdminFeatures,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/scores',
        name: 'scores',
        component: Scores,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/rewards',
        name: 'rewards',
        component: Rewards,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/topup',
        name: 'topup',
        component: TopUp,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/addadvertisers',
        name: 'addadvertisers',
        component: Addadvertisers,
        meta: {
            requiresAuth: true,
        }
    },    
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            requiresVisitor: true,
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/adlist',
        name: 'adlist',
        component: AdList,
        meta: {
            requiresAuth: true,
            reload: true,
         
        }
    },
    {
        path: '/adform/:id?',
        name: 'adform',
        component: Adform,
        meta: {
            requiresAuth: true,
        }
    },       
    {
        path: '/adformnew',
        name: 'adformnew',
        component: Adformnew,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/editprofile',
        name: 'editprofile',
        component: Editprofile,
        meta: {
          requiresAuth: true,
        }
      }, 
      {
        path: '/transactions',
        name: 'transactions',
        component: Transaction,
        meta: {
          requiresAuth: true,
        }
      }, 
      {
        path: '/refund',
        name: 'refund',
        component: Refund,
        meta: {
          requiresAuth: true,
        }
      }, 
      {
        path: '/changepassword',
        name: 'changepassword',
        component: Changepassword,
        meta: {
          requiresAuth: true,
        }
      }, 


      
      
]

export default routes;
